import * as constants from "./../constants";
import { getVehicleNumberValues, getAvatarStringFromName,getDateInStringDDMMMYYYY, getVehicleNumberValuesDWeb } from "./utils/utils"
import * as logger from './../../logger';
export const getFastagVehiclesData = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: `/fastag/vehicles`,
    data,
    success: (response) => populateFastagVehiclesData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});
const populateFastagVehiclesData = (response) => {
  var fastagVehiclesData = [];
  if (response.status && response.status.code && response.status.code == 200 && response.response) {
    let data = response.response;
    for (const key in data) {
      if (Object.hasOwnProperty.call(data, key)) {
        const values = data[key];
        if (values && Array.isArray(values) && values.length > 0) {
          for (let index = 0; index < values.length; index++) {
            const element = values[index];
            var vehicleNumArray = getVehicleNumberValues(values[index].vehicleNumber)
            var vehicleNumArrayValue = getVehicleNumberValuesDWeb(values[index].vehicleNumber);
            let data = {
              ...element,
              status: key,
              dateDisplay:element && element.balanceFetchedAt?getDateInStringDDMMMYYYY(element.balanceFetchedAt) : null,
              vehicleNumberPrefix: vehicleNumArray[0],
              vehicleNumberSuffix: vehicleNumArray[1],
              vehicleNumArrayDweb: vehicleNumArrayValue,
            }
            fastagVehiclesData.push(data);
          }
        }
      }
    }
  }
  return { type: constants.GET_FASTAG_VEHICLES_DATA, payload: fastagVehiclesData };
}

export const getSingleFastTagDetails = (fastTagId, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: `/fastag/${fastTagId}/details`,
    success: (response) => populateSingleFastTagDetails(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
})
export const getWalletBalance = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: `/rewards/amount`,
    success: (response) => populateWalletBalance(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
})

const populateSingleFastTagDetails = (response) => {
  let payloadData = response.response;
  var vehicleNumArray = getVehicleNumberValues(payloadData.vehicleNumber)
  var vehicleNumArrayValue = getVehicleNumberValuesDWeb(payloadData.vehicleNumber);
  payloadData.vehicleNumberPrefix=vehicleNumArray[0];
  payloadData.vehicleNumberSuffix= vehicleNumArray[1];
  payloadData.vehicleNumArrayDweb= vehicleNumArrayValue;
  return { type: constants.GET_SINGLE_FASTTAG_DETAILS, payload: payloadData }
}

export const getFastTagRechargeStatus = (transactionId, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: '/fastag/recharge/' + transactionId,
    success: (response) => populateFastTagRechargeStatus(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

const populateFastTagRechargeStatus = (response) => {

  const payloadData = response.response;
  payloadData.vehicleNumberArray = getVehicleNumberValuesDWeb(payloadData && payloadData.vehicleNumber ? payloadData.vehicleNumber : "");
  return { type: constants.GET_FASTTAG_RECHARGE_STATUS, payload: payloadData }

}
const populateWalletBalance = (response) => {

  const payloadData = response.response && response.response.amount? response.response.amount:0;
  return { type: constants.GET_WALLET_BALANCE, payload: payloadData }

}
export const getRechargeLink = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: `/fastag/recharge`,
    data,
    success: (response) => populateNoStateUpdate(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});
export const EditFastagExpense = (id,data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "PUT",
    url: `/fastag/${id}/expense`,
    data,
    success: (response) => populateNoStateUpdate(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});
export const getBalance = (id, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: `/fastag/${id}/balance`,
    success: (response) => populateNoStateUpdate(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});
const populateNoStateUpdate= (response) => {
  return { type: null, payload: null };
}